import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, } from 'react-icons/fa';
import axios from '../api/axios';
import { validateEjercicioForm } from '../Validations/ValidationsEjercicio';

const EjerciciosTable = () => {
  const [ejercicios, setEjercicios] = useState([]);
  const [newEjercicio, setNewEjercicio] = useState({ anio: '' });
  const [editingEjercicio, setEditingEjercicio] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    fetchEjercicios();
  }, []);

  const fetchEjercicios = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get('/ejercicios');
      setEjercicios(response.data);
    } catch (err) {
      setError('Error al cargar los ejercicios. Por favor, intente de nuevo.');
      console.error('Error fetching ejercicios:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setValidationErrors({});

    const errors = await validateEjercicioForm(newEjercicio);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    try {
      if (editingEjercicio) {
        await axios.put(`/ejercicios/${editingEjercicio.id}`, { anio: parseInt(newEjercicio.anio, 10) });
      } else {
        await axios.post('/ejercicios', { anio: parseInt(newEjercicio.anio, 10) });
      }
      fetchEjercicios();
      setNewEjercicio({ anio: '' });
      setEditingEjercicio(null);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Error al guardar el ejercicio. Por favor, intente de nuevo.');
      }
      console.error('Error saving ejercicio:', err);
    }
  };

  const handleEdit = (ejercicio) => {
    setEditingEjercicio(ejercicio);
    setNewEjercicio({ anio: ejercicio.anio.toString() });
    setValidationErrors({});
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Está seguro de que desea eliminar este ejercicio?')) {
      try {
        await axios.delete(`/ejercicios/${id}`);
        fetchEjercicios();
      } catch (err) {
        setError('Error al eliminar el ejercicio. Por favor, intente de nuevo.');
        console.error('Error deleting ejercicio:', err);
      }
    }
  };

  if (isLoading) {
    return <div className="text-center mt-8">Cargando...</div>;
  }

  if (error) {
    return <div className="text-center mt-8 text-red-500">{error}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-bold mb-4 font-serif">Gestión de Ejercicios</h2>
      <form onSubmit={handleSubmit} className="mb-8">
        <div className="flex items-center">
          <input
            type="number"
            value={newEjercicio.anio}
            onChange={(e) => setNewEjercicio({ anio: e.target.value })}
            placeholder="Año del ejercicio"
            className={`border rounded-l-lg p-2 flex-grow ${validationErrors.anio ? 'border-red-500' : ''}`}
            min="1900"
            max="2100"
            required
          />
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded-r-lg hover:bg-blue-600 transition-colors duration-200"
          >
            {editingEjercicio ? 'Actualizar' : 'Agregar'}
          </button>
        </div>
        {validationErrors.anio && <p className="text-red-500 text-xs mt-1">{validationErrors.anio}</p>}
      </form>
      <table className="w-full">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Año</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {ejercicios.map((ejercicio) => (
            <tr key={ejercicio.id}>
              <td className="px-6 py-4 whitespace-nowrap">{ejercicio.anio}</td>
              <td className="px-6 py-4 whitespace-nowrap">
                <button
                  onClick={() => handleEdit(ejercicio)}
                  className="text-blue-600 hover:text-blue-900 mr-2"
                >
                  <FaEdit className='h-5 w-5' />
                </button>
                <button
                  onClick={() => handleDelete(ejercicio.id)}
                  className="text-red-600 hover:text-red-900"
                >
                  <FaTrash className='h-5 w-5'/>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EjerciciosTable;